import { Component, Input } from '@angular/core'
import { Customer } from '../../submission.queries'

@Component({
  selector: 'empty-customer-expired',
  template: `
    <div class="text-center bottom-buffer empty-state">
      <i class="fas fa-times-circle"></i>
      <h3>Your subscription has ended for {{ customer.businessName }}.</h3>

      Click below to restart your subscription:
      <div class="top-buffer">
        <a [routerLink]="['/dashboard', customer.id, 'plan']" class="orange-button">Choose Plan</a>
      </div>
    </div>
  `
})
export class EmptyCustomerExpiredComponent {
  @Input() customer: Customer;
}
